import UserService from '@appServices/User/userService';
import Button from '@sharedComponents/Button';
import Divider from '@sharedComponents/Divider';
import FlexBox from '@sharedComponents/FlexBox';
import Select from '@sharedComponents/Select';
import Typography from '@sharedComponents/Typography';
import { getSupportedLanguageOptions } from '@utils/languageNames';
import { useTranslation } from 'react-i18next';

import styles from './style.module.css';

const userService = new UserService();

export default function LoginFooter({ legalurl = '/?action=mentions_legales', version }) {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language?.split('-')[0] || 'fr';

    const languages = getSupportedLanguageOptions(i18n);

    return (
        <FlexBox
            flexDirection="column"
            additionnalStyles={{ '--border-color-neutral-tertiary': 'var(--background-color-neutral-secondary)' }}
        >
            <Divider />
            <div className={styles.loginFooterRow}>
                <FlexBox additionnalStyles={{ '--text-color-neutral-primary': 'var(--text-color-neutral-secondary)' }}>
                    <Select
                        options={languages}
                        value={currentLang}
                        onChange={(opt) => {
                            i18n.changeLanguage(opt.value);
                            userService.setLanguage(opt.value).catch(() => {});
                        }}
                        isSearchable={false}
                        menuPlacement="top"
                    />
                </FlexBox>
                {version && (
                    <Typography fontSize="xs" color="neutral-secondary">
                        {version}
                    </Typography>
                )}
                <Button
                    label={t('Legal notices')}
                    action={legalurl}
                    ghost
                    style={{ '--background-color': 'var(--text-color-branded-primary)' }}
                />
            </div>
        </FlexBox>
    );
}
